<template>
  <div class="pa-0 ma-0">
    <v-row
      v-if="showDateFrom === true && showDateTo === false"
      class="v-row-unique"
    >
      <v-col class="only-date-start mx-3 mb-2">
        <span class="mr-1">{{ $tc("date.from") }}</span>
        <v-icon @click="changeDateBy('dateFrom', 'yesterday')" class="mr-1">
          fa-angle-left
        </v-icon>
        <v-text-field
          v-model="formattedDateFrom"
          class="only-inputDate fill-width"
          placeholder="dd/mm/yyyy"
          dense
          flat
          solo
          hide-details
          maxlength="10"
          v-mask="'##/##/####'"
          @blur="onManualDateFromChange"
        />
        <v-menu
          ref="menuFrom"
          v-model="menuFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-1" v-bind="attrs" v-on="on"
              >far fa-calendar</v-icon
            >
          </template>
          <v-date-picker
            v-model="dateFromInternal"
            @input="onDateFromPickerInput"
            @change="menuFrom = false"
            locale="es"
            :first-day-of-week="1"
          />
        </v-menu>
        <v-icon @click="changeDateBy('dateFrom', 'laterday')" class="ml-1">
          fa-angle-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row v-else class="v-row">
      <v-col cols="12" class="date">
        <span class="mr-1">{{ $tc("date.from") }}</span>
        <v-icon @click="changeDateBy('dateFrom', 'yesterday')" class="mr-1">
          fa-angle-left
        </v-icon>
        <v-text-field
          v-model="formattedDateFrom"
          class="inputDate"
          placeholder="dd/mm/yyyy"
          dense
          flat
          solo
          hide-details
          maxlength="10"
          v-mask="'##/##/####'"
          @blur="onManualDateFromChange"
        />
        <v-menu
          ref="menuFromSingle"
          v-model="menuFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-1" v-bind="attrs" v-on="on"
              >far fa-calendar</v-icon
            >
          </template>
          <v-date-picker
            v-model="dateFromInternal"
            @input="onDateFromPickerInput"
            @change="menuFrom = false"
            locale="es"
            :first-day-of-week="1"
          />
        </v-menu>
        <v-icon @click="changeDateBy('dateFrom', 'laterday')" class="ml-1">
          fa-angle-right
        </v-icon>
      </v-col>

      <v-col v-show="showDateTo" cols="10" sm="5" md="5" class="date">
        <span class="mr-1">{{ $tc("date.to") }}</span>
        <v-icon
          @click="changeDateBy('dateTo', 'yesterday')"
          class="mr-1"
          :disabled="checkTo"
        >
          fa-angle-left
        </v-icon>
        <v-text-field
          v-model="formattedDateTo"
          class="inputDate"
          placeholder="dd/mm/yyyy"
          dense
          flat
          solo
          hide-details
          :disabled="checkTo"
          maxlength="10"
          v-mask="'##/##/####'"
          @blur="onManualDateToChange"
        />
        <v-menu
          ref="menuTo"
          v-model="menuTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              :disabled="checkTo"
            >
              far fa-calendar
            </v-icon>
          </template>

          <v-date-picker
            v-model="dateToInternal"
            @input="onDateToPickerInput"
            @change="menuTo = false"
            locale="es"
            :first-day-of-week="1"
          />
        </v-menu>
        <v-icon
          @click="changeDateBy('dateTo', 'laterday')"
          class="ml-1"
          :disabled="checkTo"
        >
          fa-angle-right
        </v-icon>
      </v-col>

      <v-tooltip right v-if="showCheck">
        <template v-slot:activator="{ on }">
          <span v-on="on" class="d-flex align-center ml-2 mr-n2">
            <v-simple-checkbox
              :ripple="false"
              color="accent"
              v-model="checkTo"
            />
          </span>
        </template>
        <span>{{ $tc("changeSchedule.caducity") }}</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import dates from "../../store/common/date";

export default {
  props: {
    showDate: Boolean,
    showCheck: {
      type: Boolean,
      default: true,
    },
    showDateFrom: {
      type: Boolean,
      default: true,
    },
    showDateTo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      debounceTimer: null,
      menuFrom: false,
      menuTo: false,
      dateFromInternal: dates.state.dateFrom || moment().format("YYYY-MM-DD"),
      dateToInternal: dates.state.dateTo || moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    dateFrom: {
      get() {
        return dates.state.dateFrom;
      },
      set(date) {
        if (!moment(date, "YYYY-MM-DD", true).isValid()) return;
        if (moment(date).isAfter(dates.state.dateTo)) {
          this.setDateTo(date);
        }
        this.setDate(date);
      },
    },
    dateTo: {
      get() {
        return dates.state.dateTo;
      },
      set(value) {
        if (!moment(value, "YYYY-MM-DD", true).isValid()) return;
        if (moment(value).isBefore(dates.state.dateFrom)) {
          this.setDate(value);
        }
        this.setDateTo(value);
      },
    },
    checkTo: {
      get() {
        return dates.state.checkTo;
      },
      set(newValue) {
        this.setCheckTo(newValue);
      },
    },
    formattedDateFrom: {
      get() {
        if (!this.dateFrom) return "DD/MM/YYYY";
        const m = moment(this.dateFrom, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD/MM/YYYY") : "";
      },
      set(value) {
        const parsed = moment(value, "DD/MM/YYYY", true);
        if (parsed.isValid()) {
          this.dateFrom = parsed.format("YYYY-MM-DD");
        }
      },
    },
    formattedDateTo: {
      get() {
        if (!this.dateTo) return "DD/MM/YYYY";
        const m = moment(this.dateTo, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD/MM/YYYY") : "";
      },
      set(value) {
        const parsed = moment(value, "DD/MM/YYYY", true);
        if (parsed.isValid()) {
          this.dateTo = parsed.format("YYYY-MM-DD");
        }
      },
    },
  },
  watch: {
    dateFrom(newVal) {
      if (moment(newVal).isValid()) this.dateFromInternal = newVal;
    },
    dateTo(newVal) {
      if (moment(newVal).isValid()) this.dateToInternal = newVal;
    },
  },
  methods: {
    onDateFromPickerInput(value) {
      if (!moment(value, "YYYY-MM-DD", true).isValid()) return;
      if (moment(value).isAfter(this.dateTo)) {
        this.setDateTo(value);
      }
      this.setDate(value);
      this.dateFromInternal = value;
    },
    onDateToPickerInput(value) {
      if (!moment(value, "YYYY-MM-DD", true).isValid()) return;
      if (moment(value).isBefore(this.dateFrom)) {
        this.setDate(value);
      }
      this.setDateTo(value);
      this.dateToInternal = value;
    },
    onManualDateFromChange() {
      const parsed = moment(this.formattedDateFrom, "DD/MM/YYYY", true);
      if (parsed.isValid()) {
        this.dateFrom = parsed.format("YYYY-MM-DD");
        this.dateFromInternal = this.dateFrom;
      } else {
        this.$nextTick(() => {
          const fmt = moment(this.dateFrom, "YYYY-MM-DD").format("DD/MM/YYYY");
          const el = this.$el.querySelector(".inputDate input");
          if (el) el.value = fmt;
        });
      }
    },
    onManualDateToChange() {
      const parsed = moment(this.formattedDateTo, "DD/MM/YYYY", true);
      if (parsed.isValid()) {
        this.dateTo = parsed.format("YYYY-MM-DD");
        this.dateToInternal = this.dateTo;
      } else {
        this.$nextTick(() => {
          const fmt = moment(this.dateTo, "YYYY-MM-DD").format("DD/MM/YYYY");
          const inputs = this.$el.querySelectorAll(".inputDate input");
          if (inputs && inputs[1]) inputs[1].value = fmt;
        });
      }
    },
    changeDateBy(model, action) {
      const actual = this[model];
      if (!actual || !moment(actual, "YYYY-MM-DD", true).isValid()) return;
      const newDate =
        action === "yesterday"
          ? moment(actual).subtract(1, "days")
          : moment(actual).add(1, "days");

      const formatted = newDate.format("YYYY-MM-DD");
      if (model === "dateFrom") {
        this.dateFrom = formatted;
        this.dateFromInternal = formatted;
      } else {
        this.dateTo = formatted;
        this.dateToInternal = formatted;
      }
    },
    setDate(date) {
      dates.commit("setDateFrom", date);
    },
    setDateTo(date) {
      dates.commit("setDateTo", date);
    },
    setCheckTo(value) {
      dates.commit("setCheckTo", value);
    },
  },
};
</script>
<style scoped>
.v-row-unique {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
}
.v-row {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 2px;
  margin-right: 2px;
  justify-content: space-between;
}
.only-date-start {
  display: flex;
  align-items: center;
  max-height: 40px;
  border-radius: 5px;
  border: 1px solid rgb(126, 126, 126);
  padding: 5px;
}
.date {
  display: flex;
  align-items: center;
  max-width: 235px;
  max-height: 40px;
  border-radius: 5px;
  border: 1px solid rgb(126, 126, 126);
  padding: 5px;
}
.only-inputDate {
  font-size: 18px !important;
}
.inputDate {
  font-size: 18px !important;
  width: 130px;
}
.inputDate .v-input__control {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
@media (max-width: 768px) {
  .date,
  .only-date-start {
    max-width: 100%;
    margin-bottom: 10px;
  }
  .v-icon {
    font-size: 18px;
  }
  .inputDate {
    font-size: 18px !important;
  }
}
@media (min-width: 769px) {
  .date {
    width: 50%;
  }
}
</style>
